<template>
<div class="container page-frame">
    <Breadcrumbs :here="'月払い請求書発行'"
                 :ancestries="ancestries"/>
    <div class="row">
        <div class="col h2"
             :style="{ fontSize: FontSizes.large1}">{{ staff.userName }}さんの月払い請求書発行ページ</div>
    </div>
    <div class="row">
        <div class="col h3"
             :style="{ fontSize: FontSizes.middle1}">{{ lastMonthText }}末締めの月払い請求書発行</div>
    </div>
    <div class="row">
        <div class="col col-lg-8 container invoice-table">
            <div class="row">
                <div class="col"><span class="wrap-text">配布委託料</span></div>
                <div class="col text-right"><span class="wrap-text">&yen;{{ totalAmount.toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}円</span></div>
            </div>
            <div class="row">
                <div class="col"><span class="wrap-text">前払い利用済み金額</span></div>
                <div class="col text-right"><span class="wrap-text">&yen;{{ prepaidAmount.toLocaleString() }}円</span></div>
            </div>
            <div class="row">
                <div class="col"><span class="wrap-text">配布委託料残高</span></div>
                <div class="col text-right"><span class="wrap-text">&yen;{{ compensationBalance.toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}円</span></div>
            </div>
            <div class="row billing-amount-row">
                <div class="col"><span class="wrap-text">請求金額（消費税込み）</span></div>
                <div class="col text-right"><span class="wrap-text">&yen;{{ billingAmount.toLocaleString() }}円</span></div>
            </div>
            <div class="row">
                <div class="col"><span class="wrap-text">振込手数料</span></div>
                <div class="col text-right"><span class="wrap-text">&yen;{{ transferFee.toLocaleString() }}円</span></div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center my-2">
        <div class="col col-lg-8 container">
            <button class="btn btn-primary w-100"
                    @click="onClickSubmitInvoice">この金額で請求書を発行する</button>
            <div v-show="!invoiceApproval.accept">請求書を発行すると<span class="invoice-approved">★{{ approvedText }}</span>となります。</div>
            <div class="approval-state my-2"
                 :style="{ fontSize: FontSizes.large1}"
                 :class="invoiceApproval.accept ? 'invoice-approved' : 'invoice-disapproved'">★ {{ approvalStateText }}</div>
            <div class="submit-box" :style="{height: submitBoxHeight + 'px'}">
                <div class="submit-box-header"
                     @click="onClickSubmitBoxHeader">
                    <div class="header-inner"
                         :style="{ fontSize: FontSizes.large1}">内容問合せ</div>
                    <div class="extract-button">
                        <div class="arrow-mark"
                             :class="{'arrow-mark-inverted': isSubmitBoxOpen}"></div>
                    </div>
                </div>
                <template v-if="existsApprovalMessageContent">
                    <div class="message-tip">問合せ済みメッセージ</div>
                    <div class="message-thread container my-2">
                        <div v-for="message in invoiceApproval.messages"
                             :key="message.vForKey"
                             :style="{fontSize: FontSizes.small1}"
                             class="row message-row">
                            <div class="col-8 text-left">● {{ message.message }}</div>
                            <div class="col-4 align-self-center">
                                <span class="wrap-text">{{ message.datetime }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="message-thread message-thread-height-measure-dummy-div container my-2"
                         ref="messageThreadHeightMeasureDummyDiv">
                        <div v-for="message in invoiceApproval.messages"
                             :key="message.vForKey"
                             :style="{fontSize: FontSizes.small1}"
                             class="row message-row">
                            <div class="col-8 text-left">● {{ message.message }}
                            </div>
                            <div class="col-4 align-self-center">
                                <span class="wrap-text">{{ message.datetime }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="message-tip">このメッセージに追記する</div>
                </template>
                <div>
                    <textarea v-model="messageText"></textarea>
                </div>
                <button class="btn btn-secondary submit-button"
                        @click="onClickSubmitMessage"
                        :disabled="!canClickSubmitMessage()">メッセージを送信する</button>
                <div v-show="invoiceApproval.accept">問合せメッセージを送信すると<span class="invoice-disapproved">★{{ disapprovedText }}</span>となります。</div>
            </div>

        </div>
    </div>

    <div class="row justify-content-between table-title-row">
        <div class="col-6 col-md-6 h3"
             :style="{ fontSize: FontSizes.large1}">{{ lastMonthText }}の配布記録</div>
        <button class="btn btn-info col-12 col-md-4 align-self-center"
                @click="onClickDownloadInvoiceDetailExcel">請求明細Excelファイル</button>
    </div>
    <div class="row mt-2">
        <div class="col search-text-wrap">
            <input type="text"
                   placeholder="検索"
                   v-model="searchText">
            <div class="clear-button"
                 @click="onClickClearSearch"></div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <table class="table">
                <thead>
                    <tr>
                        <th>配布日</th>
                        <th>商品ID</th>
                        <th>商品名</th>
                        <th>配布地区</th>
                        <th>配布エリア</th>
                        <th>配布数合計</th>
                        <th>配布単価</th>
                        <th>委託費合計</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="pAmount in searchedPayAmounts"
                        :key="pAmount.vForKey">
                        <td>{{ pAmount.dateString }}</td>
                        <td>{{ pAmount.productId }}</td>
                        <td>{{ pAmount.productName }}</td>
                        <td>{{ pAmount.areaAddress }}</td>
                        <td>{{ pAmount.place }}</td>
                        <td>{{ pAmount.resultCount }}</td>
                        <td>&yen;{{ pAmount.sPrice.toFixed(3) }}</td>
                        <td>&yen;{{ pAmount.amount.toFixed(3) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref, watch} from "vue";
import {loadingOverlayStateStore} from "@/stores/loading-overlay-state-store";
import Breadcrumbs, {ancestryType} from "@/components/Breadcrumbs.vue";
import {logoutMessages, subPaths} from "@/utils/consts";
import {authStore} from "@/stores/auth-store";
import {authLevels} from "@/data-models/auth";
import {Staff} from "@/data-models/staff";
import {useRoute, useRouter} from "vue-router";
import {FontSizes} from "@/utils/font-sizes";
import {backendApi} from "@/utils/backend-api";
import {addMonths, format, isBefore} from "date-fns";
import ja from "date-fns/locale/ja";
import {PaymentAmount} from "@/data-models/payment-amount";
import {PaymentHistory} from "@/data-models/payment-history";
import {paymentTypes} from "@/data-models/daily-record";
import {InvoiceApproval} from "@/data-models/invoice-approval";
import {ApiResponse} from "@/data-models/api-response";
import {downloadExcelFile} from "@/utils/file-utils";

export default defineComponent({
    name: "InvoiceOfMonthPage",
    components: {
        Breadcrumbs,
    },
    setup() {

        const approvedText = "請求書承認および発行済み",
                disapprovedText = "請求書未承認"

        const staffId = ref<number>(-1),
                ancestries = ref<ancestryType[]>([] as ancestryType[]),
                staff = ref<Staff>(new Staff()),
                lastMonthText = ref<string>("--月"),
                searchedPayAmounts = ref<PaymentAmount[]>([] as PaymentAmount[]),
                searchText = ref<string>(""),
                totalAmount = ref<number>(0),
                prepaidAmount = ref<number>(0),
                compensationBalance = ref<number>(0),
                billingAmount = ref<number>(0),
                transferFee = ref<number>(0),
                messageText = ref<string>(""),
                submitBoxHeight = ref<number>(40),
                isSubmitBoxOpen = ref<boolean>(false),
                invoiceApproval = ref<InvoiceApproval>(new InvoiceApproval()),
                approvalStateText = ref<string>(""),
                messageThreadHeightMeasureDummyDiv = ref<HTMLDataElement>()

        let payAmounts = [] as PaymentAmount[]

        const route = useRoute(),
                router = useRouter()



        const update = async () => {
            const staffResp = await backendApi.loadStaffById(staffId.value)

            if (staffResp.isAuthorized) {
                staff.value = Staff.fromJson(staffResp.value)

                updateAncestries()
                await updatePaymentAmounts()
                updateTotalAmount()
                await updatePrepaidAmount()
                compensationBalance.value = totalAmount.value - prepaidAmount.value
                await updateBankTransferFee()
                billingAmount.value = Math.round(compensationBalance.value - transferFee.value)

                await updateInvoiceApproval()
                updateSubmitBoxHeight()


            } else {
                await router.push({
                    path: subPaths.LOGGED_OUT,
                    query: {
                        logout_message: logoutMessages.TOKEN_EXPIRED.key
                    }
                })
            }
        }

        const updatePaymentAmounts = async () => {
            const pAmountResp = await backendApi.inquirePaymentAmountsWithProductName(staffId.value, 1)
            console.log(pAmountResp)
            if (pAmountResp.isAuthorized) {
                payAmounts = PaymentAmount.fromJsonArrToArr(pAmountResp.value)
                updateSearchedPayAmounts()
                // console.log(payAmounts)
            } else {
                await router.push({
                    path: subPaths.LOGGED_OUT,
                    query: {
                        logout_message: logoutMessages.TOKEN_EXPIRED.key
                    }
                })
            }
        }

        const onClickDownloadInvoiceDetailExcel = async () => {

            loadingOverlayStateStore.commit("switchLoadingState", {
                show: true,
                message: "請求明細Excelファイルダウンロード…",
                shouldTimeOut: false,
            })

            const resp = await backendApi.inquireMonthlyInvoiceDetailExcel(staffId.value, 1)
            if (resp.isAuthorized) {
                await downloadExcelFile(resp)
            } else {
                await router.push({
                    path: subPaths.LOGGED_OUT,
                    query: {
                        logout_message: logoutMessages.TOKEN_EXPIRED.key
                    }
                })
            }
            loadingOverlayStateStore.commit("fadeout")
        }

        const updateSearchedPayAmounts = () => {
            searchedPayAmounts.value.splice(0)
            payAmounts.forEach(pAmount => {
                if (searchText.value.length === 0) {
                    // 検索文字列が空白の時は全件表示する
                    searchedPayAmounts.value.push(pAmount)
                } else {
                    if (pAmount.stringForSearch.includes(searchText.value)) {
                        searchedPayAmounts.value.push(pAmount)
                    }
                }
            })

            searchedPayAmounts.value.sort((a, b) => {
                if (isBefore(b.date as Date, a.date as Date)) {
                    return 1
                } else if (isBefore(a.date as Date, b.date as Date)) {
                    return -1
                } else {
                    if (a.areaId > b.areaId) {
                        return 1
                    } else if (b.areaId > a.areaId) {
                        return -1
                    } else {
                        return a.productId - b.productId
                    }
                }
            })
        }

        const updateTotalAmount = () => {
            totalAmount.value = 0
            payAmounts.forEach(pAmount => {
                totalAmount.value += pAmount.amount
            })
            totalAmount.value = Math.round(totalAmount.value * 1000) / 1000
        }

        const updatePrepaidAmount = async () => {

            prepaidAmount.value = 0

            const historyResp = await backendApi.inquirePaymentHistories(staff.value.staffId, 1)
            if (historyResp.isAuthorized) {
                const histories = PaymentHistory.fromJsonArrToArr(historyResp.value)
                histories.forEach(hist => {
                    if (hist.paymentType === paymentTypes.ADVANCE_PAYMENT) {
                        prepaidAmount.value += hist.amount
                    }
                })

                prepaidAmount.value = Math.floor(prepaidAmount.value)

            } else {
                await router.push({
                    path: subPaths.LOGGED_OUT,
                    query: {
                        logout_message: logoutMessages.TOKEN_EXPIRED.key
                    }
                })
            }
        }

        const updateBankTransferFee = async () => {
            const transferFeeResp = await backendApi.inquireBankTransferFeeForMonthlyPay(staff.value.staffId, compensationBalance.value)
            if (transferFeeResp.isAuthorized) {
                // console.log(transferFeeResp.value)
                transferFee.value = transferFeeResp.value
            } else {
                await router.push({
                    path: subPaths.LOGGED_OUT,
                    query: {
                        logout_message: logoutMessages.TOKEN_EXPIRED.key
                    }
                })
            }
        }

        const updateInvoiceApproval = async () => {
            const resp = await backendApi.inquireInvoiceMessageByStaffId(staff.value.staffId)
            console.log(resp)
            if (resp.isAuthorized) {
                const approvalArr = InvoiceApproval.fromJsonArrToArr(resp.value)
                if (approvalArr.length > 0) {
                    invoiceApproval.value = approvalArr[0]
                }
                updateApprovalStateText()
            } else {
                await router.push({
                    path: subPaths.LOGGED_OUT,
                    query: {
                        logout_message: logoutMessages.TOKEN_EXPIRED.key
                    }
                })
            }
        }

        const updateAncestries = () => {
            ancestries.value = [
                {
                    name: staff.value.displayName + "さん",
                    pathObj: {
                        path: subPaths.MY_PAGE,
                        query: {
                            staff_id: staff.value.staffId,
                        },
                    }
                }
            ]

            if (authStore.getters.authLevel !== authLevels.DIST_STAFF) {
                ancestries.value.unshift({
                    name: staff.value.branch,
                    pathObj: {
                        path: subPaths.BRANCH_PAGE,
                        query: {
                            name: staff.value.branch
                        }
                    }
                })
                ancestries.value.unshift({
                    name: "ホーム",
                    pathObj: subPaths.HOME
                })
            }
        }

        watch(() => searchText.value, () => {
            console.log("searchText.value updated")
            updateSearchedPayAmounts()
        })

        const onClickClearSearch = () => {
            searchText.value = ""
        }

        const onClickSubmitInvoice = async () => {
            console.log("onClickSubmitInvoice")

            loadingOverlayStateStore.commit("switchLoadingState", {
                show: true,
                message: "請求書発行中…",
                shouldTimeOut: false,
            })

            isSubmitBoxOpen.value = false
            updateSubmitBoxHeight()

            let approvalResp: ApiResponse

            // 請求内容を承認したというメッセージを送る
            if (invoiceApproval.value.id === -1) {

                // 承認メッセージの新規発行
                approvalResp = await backendApi.inquireForCreateApproval(staff.value.staffId, approvedText, true)

            } else {

                // 承認メッセージの更新
                approvalResp = await backendApi.inquireForUpdateApproval(staff.value.staffId, invoiceApproval.value.id, approvedText, true)
            }

            console.log(approvalResp)

            if (approvalResp.isAuthorized) {

                // 承認メッセージが受理されたことを確認して…
                const approvalArr = InvoiceApproval.fromJsonArrToArr(approvalResp.value)
                if (approvalArr.length > 0) {
                    invoiceApproval.value = approvalArr[0]
                }

                updateApprovalStateText()

                // PDF表示ページへ遷移する。
                await router.push({
                    path: subPaths.MY_PAGE_INVOICE_OF_MONTH_PDF,
                    query: {
                        staff_id: staffId.value
                    }
                })

            } else {
                await router.push({
                    path: subPaths.LOGGED_OUT,
                    query: {
                        logout_message: logoutMessages.TOKEN_EXPIRED.key
                    }
                })
                loadingOverlayStateStore.commit("fadeout")
            }
        }

        onMounted(async () => {

            loadingOverlayStateStore.commit("switchLoadingState", {
                show: true,
                message: "月払い請求書ページ…",
                shouldTimeOut: false,
            })

            const stId = route.query.staff_id as string
            if (stId) {
                staffId.value = parseInt(stId)
                await update()
            }

            lastMonthText.value = format(addMonths(new Date(), -1), "MMM", { locale:ja })

            loadingOverlayStateStore.commit("fadeout")

            watchAndUpdateSubmitBoxOpenHeight()
        })

        const onClickSubmitBoxHeader = () => {
            isSubmitBoxOpen.value = !isSubmitBoxOpen.value
            updateSubmitBoxHeight()
        }


        const submitBoxOpenHeight = ref<number>(250)
        let messageThreadOldHeight = 0
        const watchAndUpdateSubmitBoxOpenHeight = () => {
            setInterval(() => {
                if (messageThreadHeightMeasureDummyDiv.value) {
                    // console.log("messageThreadHeightMeasureDummyDiv.value.clientHeight", messageThreadHeightMeasureDummyDiv.value.clientHeight)
                    const messageThreadHeight = messageThreadHeightMeasureDummyDiv.value.clientHeight
                    if (messageThreadHeight !== messageThreadOldHeight) {
                        console.log("messageThreadHeight", messageThreadHeight)
                        messageThreadOldHeight = messageThreadHeight
                        submitBoxOpenHeight.value = messageThreadHeight + 250
                        updateSubmitBoxHeight()
                    }
                }
            }, 50)
        }

        const updateSubmitBoxHeight = () => {
            if (isSubmitBoxOpen.value) {
                submitBoxHeight.value = submitBoxOpenHeight.value
            } else {
                submitBoxHeight.value = 40
            }
        }

        const onClickSubmitMessage = async () => {

            let resp: ApiResponse

            if (invoiceApproval.value.id === -1) {
                resp = await backendApi.inquireForCreateApproval(staff.value.staffId, messageText.value, false)

            } else {
                resp = await backendApi.inquireForUpdateApproval(staff.value.staffId, invoiceApproval.value.id, messageText.value, false)
            }

            console.log(resp)

            if (resp.isAuthorized) {
                const approvalArr = InvoiceApproval.fromJsonArrToArr(resp.value)
                if (approvalArr.length > 0) {
                    invoiceApproval.value = approvalArr[0]
                }

                messageText.value = ""
                updateApprovalStateText()
                updateSubmitBoxHeight()

            } else {
                await router.push({
                    path: subPaths.LOGGED_OUT,
                    query: {
                        logout_message: logoutMessages.TOKEN_EXPIRED.key
                    }
                })
            }
        }

        const canClickSubmitMessage = (): boolean => {
            return messageText.value.length > 0
        }

        const existsApprovalMessageContent = (): boolean => {
            return invoiceApproval.value.id !== -1
                    && invoiceApproval.value.message.length > 0
        }


        const updateApprovalStateText = () => {
            approvalStateText.value = invoiceApproval.value.accept
                    ? approvedText
                    : disapprovedText
        }

        const downloadInvoicePDF = (resp: ApiResponse) => {

            const fileData = resp.value.file_data;
            const fileName = resp.value.file_name;

            const a = document.createElement("a");
            a.href = "data:application/pdf;charset=UTF-8;base64," + fileData
            a.download = fileName;
            a.type = "application/pdf"
            a.click();
        }

        return {
            staff,
            ancestries,
            FontSizes,
            lastMonthText,
            searchText,
            onClickClearSearch,
            searchedPayAmounts,
            totalAmount,
            prepaidAmount,
            compensationBalance,
            billingAmount,
            transferFee,
            onClickSubmitInvoice,
            messageText,
            isSubmitBoxOpen,
            submitBoxHeight,
            onClickSubmitBoxHeader,
            onClickSubmitMessage,
            canClickSubmitMessage,
            invoiceApproval,
            existsApprovalMessageContent,
            approvalStateText,
            approvedText,
            disapprovedText,
            messageThreadHeightMeasureDummyDiv,
            onClickDownloadInvoiceDetailExcel,
        }
    }
})
</script>

<style scoped lang="scss">
.page-frame {
    height: 100%;
}

.search-text-wrap {
    border: lightgray 1px solid;
    border-radius: 5px;
    height: 40px;

    input {
        border: none;
        outline: none;
        height: 38px;
        width: calc(100% - 40px);
        left: 0;
        position: absolute;
        text-indent: 5px;
        border-radius: 5px;
    }

    .clear-button {
        position: absolute;
        right: 0;
        top: 0;
        width: 40px;
        height: 40px;
        border-radius: 5px;

        &:hover {
            opacity: 0.7;
        }

        &:active {
            opacity: 0.5;
        }

        &::before {
            content: "";
            width: 30px;
            height: 4px;
            border-radius: 2px;
            background-color: lightgray;
            position: absolute;
            transform: rotate(45deg);
            top: 16px;
            left: 6px
        }

        &::after {
            content: "";
            width: 30px;
            height: 4px;
            border-radius: 2px;
            background-color: lightgray;
            position: absolute;
            transform: rotate(-45deg);
            top: 16px;
            left: 6px
        }
    }
}

.invoice-table {
    .row {
        height: 40px;
        border-bottom: 1px lightgray solid;

        .col {
            height: 40px;
            //line-height: 40px;
        }
    }

    .billing-amount-row {
        font-weight: bold;
        border-bottom: 2px lightgray solid;
    }
}

.submit-box {

    transition: height 0.5s 0s ease;
    overflow: hidden;
    border: 1px lightgray solid;
    border-radius: 5px;
    position: relative;

    .submit-box-header {
        position: relative;
        width: 100%;
        height: 40px;

        &:hover {
            opacity: 0.8;
        }

        &:active {
            opacity: 0.5;
        }

        .header-inner {
            position: absolute;
            left: 0;
            top: 0;
            height: 40px;
            line-height: 40px;
            width: calc(100% - 40px);
        }

        .extract-button {
            position: absolute;
            top: 0;
            right: 0;
            width: 40px;
            height: 40px;
            //background-color: red;

            .arrow-mark {
                position: absolute;
                margin: auto;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                width: 25px;
                height: 25px;

                &-inverted {
                    transform: rotate(180deg);
                }

                &::before {
                    content: "";
                    width: 11px;
                    height: 3px;
                    background-color: gray;
                    position: absolute;
                    transform: rotate(45deg);
                    left: 4px;
                    top: 10px;
                }

                &::after {
                    content: "";
                    width: 11px;
                    height: 3px;
                    background-color: gray;
                    position: absolute;
                    transform: rotate(-45deg);
                    left: 12px;
                    top: 10px;
                }
            }
        }

    }

    .message-tip {
        color: gray;
    }

    .message-thread {
        color: darkgray;

        //background-color: blue;
        //opacity: 0.3;

        .message-row {
            min-height: 20px;
        }

        &-height-measure-dummy-div {
            position: absolute;
            background-color: red;
            opacity: 0.3;
            overflow: visible;
            visibility: hidden;
        }

    }

    textarea {
        height: 60px;
        resize: none;
        border-radius: 4px;
        border: 1px lightgray solid;
        width: calc(100% - 10px);
        margin: 5px;
    }
}

.table-title-row {

    .h3 {
        height: 40px;
    }

    button {
        height: 40px;
    }
}

.invoice-approved {
    color: green;
}

.invoice-approved-by-branch {
    color: blue;
}

.invoice-disapproved {
    color: red;
}


</style>